import { render, staticRenderFns } from "./rolesTable.vue?vue&type=template&id=41bf979d"
import script from "./rolesTable.vue?vue&type=script&lang=js"
export * from "./rolesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports